import { KEYS } from '../Constants/Constants';

interface EndPoints {
  [index: string]: any;
}
export const URL_ENDPOINTS: EndPoints = {
  HOME: {
    SHIPMENT_DETAILS: 'web/v1/experience',
    ACTIVITY: 'web/v1/experience',
    ACTION: 'web/v1/experience',
    NUMBER_VALIDATION: 'web/v1/experience',
    LOCATION: 'web/v1/experience',
  },
  GLOBAL: {
    FEEDBACK: 'exp/v1/app/feedback/submit',
  },
  CONTENTORCONFIG: {
    COMMON: 'exp/v1/apps/contentConfig',
  },
  MEMBER: {
    DETAILS: 'exp/v1/user/details',
  },
  SEARCH: {
    GETSEARCHLOADS: 'exp/v1/load/searchLoad',
    TYPEAHEAD: 'exp/v1/load/searchLocation',
    GETLOADBYID: 'exp/v1/load/searchByRef',
    GETRECENT: 'exp/v1/user/recent/search/history',
    GETFAVORITE: 'exp/v1/user/favorite/search/history',
    UPDATEFAVORITE: 'exp/v1/user/favorite/search',
    GETWATCHLOADS: 'exp/v1/load/watched/loads',
    UPDATEWATCHED: 'exp/v1/user/watched/load',
    POSTBOOKLOAD: 'exp/v1/load/bookLoad',
  },
  MYLOADS: {
    GETALLSHIPMENTS: 'exp/v1/shp/retriveAllShipments',
    GETSHIPMENT: 'exp/v1/shp/getShipment',
    GETDOCUMENTS: 'exp/v1/doc/getDocumentList',
    GETDOCUMENTBASE64DATA: 'exp/v1/doc/getDocument',
  },
  NATNAL: {
    GETNATNALDATA: 'exp/v1/location/driverDetails',
    OVERRIDENATNALDATA: 'exp/v1/location/natnal/update',
  },
  LOAD: {
    ASSIGNEDSHIPMENTS: 'exp/v1/load/retrieveAssignedShipments',
  },
  FINANCIAL_INFO: {
    GETALLREPORTS: 'exp/v1/report/getAllReports',
    GETTAXFORMS: 'exp/v1/getTaxForms',
    EXPORT_REPORT: 'exp/v1/report/export',
    GETREPORT: 'exp/v1/report/getReport',
    GETTAXFORMPDF: 'exp/v1/getTaxFormPdf',
  },
  PREFERENCES: {
    GETPREFERENCES: 'exp/v1/user/preferences/fetch',
    UPDATEPREFERENCES: 'exp/v1/user/preferences/upsert',
  },
};

/**
 * To build request URL with provided inputs.
 * @param {string} endPoint URL category name.
 * @param {string} urlKey endpoint key name.
 * @param {*} value query string value to append to the url.
 */

export default function getURLDetails(endPoint: string, urlKey: string, value?: any) {
  return {
    get_Service_Url: function () {
      let _url = '';
      const keyValue = URL_ENDPOINTS[endPoint][urlKey];
      const API_HOST = KEYS.API_HOST;
      if (keyValue) {
        _url = `https://${API_HOST}${keyValue}`;
        _url = value
          ? _url +
            '?' +
            Object.entries(value)
              .map((item) => item.join('='))
              .join('&')
          : _url;
      } else {
        throw new Error('key value of End point URL is not matching with provided key name.');
      }
      return _url;
    },
  };
}
